import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

export default function ActionButton({
  children,
  iconName,
  className,
  ...buttonProps
}) {
  return (
    <button
      type="button"
      className={classnames('flex items-center', className)}
      {...buttonProps}
    >
      <Icon name={iconName} />
      {children && <span className="ml2">{children}</span>}
    </button>
  );
}

ActionButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
};

ActionButton.defaultProps = {
  children: null,
  className: null
};
